import React from "react"
import { Form as FormStyle, Input, Button, Icon, Select } from "antd"
import PropTypes from "prop-types"
import { autobind } from "core-decorators"
import { mapPropsToFields } from "utils/form"
import createLanguage, { langPropTypes } from "hoc/create-lang"
import ReactTelephoneInput from "react-telephone-input/lib/withStyles"
import styled from "styled-components"

// require('./index.css')

const Option = Select.Option

const FormItem = FormStyle.Item
const Form = styled(FormStyle)`
  display: flex;
  align-items: flex-end;
  .ant-form-item-control {
    line-height: 0px;
  }
  .ant-form-item {
    margin-bottom: 0px;
    max-width: 140px;
  }
`

const Clearfix = styled.div`
  width: 8px;
`

@FormStyle.create({
  mapPropsToFields: mapPropsToFields,
})
@createLanguage
@autobind
export default class OrganizationSearchForm extends React.PureComponent {
  static propTypes = {
    initialValues: PropTypes.object,
    onChangeSearch: PropTypes.func,
    lang: langPropTypes,
  }

  constructor(props) {
    super(props)
    this.state = {
      dataSearch: {},
      phone: {},
    }
  }

  async componentWillMount() {
    // if (this.props.initialValues.stationAuto) {
    //     this.changeSearch({})
    // }
  }
  changeSearch(e) {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (err) return
      const dataSearch = {}
      if (values.name) dataSearch.name = values.name
      if (values.address) dataSearch.address = values.address
      if (values.addressAPI) dataSearch.addressAPI = values.addressAPI
      if (this.state.phone) {
        dataSearch.country = this.state.phone
        dataSearch.phone =
          this.state.phone.phoneNumber !== "+"
            ? this.state.phone.phoneNumber
            : ""
      }
      if (values.status) dataSearch.status = values.status
      // Callback submit form Container Component
      this.setState({ dataSearch: dataSearch }, () =>
        this.props.onChangeSearch(dataSearch)
      )
    })
  }

  handleInputChange(telNumber, selectedCountry) {
    this.setState({
      phone: {
        phoneNumber: telNumber,
        ...selectedCountry,
      },
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const {
      lang: { t },
    } = this.props

    return (
      <Form className='fadeIn animated' onSubmit={this.changeSearch}>
        <FormItem>
          {getFieldDecorator(`status`)(
            <Select placeholder={t('organization.form.status.placeholder')} style={{ width: "140px" }}>
              <Option value='EXPIRED'>{t('organization.form.status.expired')}</Option>
              <Option value='ABOUT_TO_EXPIRE'>{t('organization.form.status.aboutToExpired')}</Option>
              <Option value='ACTIVE'>{t('organization.form.status.active')}</Option>
              {/* <Option value='UNLIMITED'>{t('organization.form.status.unlimited')}</Option> */}
            </Select>
          )}
        </FormItem>
        <Clearfix />
        <FormItem>
          {getFieldDecorator(`name`)(
            <Input placeholder={t("organization.form.name.placeholder")} />
          )}
        </FormItem>
        <Clearfix />
        <FormItem>
          {getFieldDecorator(`phone`, {
            rules: [
              {
                //required: true,
                message: t("organization.form.phone.label"),
              },
            ],
          })(
            <ReactTelephoneInput
              defaultCountry='vn'
              flagsImagePath='./images/flags.png'
              onChange={this.handleInputChange}
            // onBlur={this.handleInputBlur}
            />
          )}
        </FormItem>
        <Clearfix />
        <FormItem>
          {getFieldDecorator(`addressAPI`, {
            rules: [
              {
                //required: true,
                message: t("userSearchFrom.form.addressAPI.label"),
              },
            ],
          })(
            <Input
              placeholder={t("organization.form.addressAPI.placeholder")}
            />
          )}
        </FormItem>
        <Clearfix />
        <Button shape='circle' htmlType='submit'>
          <Icon type='search' />
        </Button>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/organization/organization-search-form/index.js